import { CONFIG_KEYS, getClientConfigBool } from '../helpers/config-helper'
import { GIFT_CARDS } from '../paths'

const FEAT_FLAG_GIFT_CARD_LANDING = getClientConfigBool(
  CONFIG_KEYS.FEAT_FLAG_GIFT_CARD_LANDING
)
const GIFT_CARDS_URL_MAP = {
  Australia: FEAT_FLAG_GIFT_CARD_LANDING
    ? GIFT_CARDS
    : 'https://www.westfieldgiftcards.com.au/online/',
  'New Zealand': 'https://giftcards.westfield.co.nz/',
}

const getGiftcardUrl = country =>
  GIFT_CARDS_URL_MAP[country] || GIFT_CARDS_URL_MAP['Australia']

export default getGiftcardUrl
